"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadLineShape = void 0;

var LineDrawer_1 = require("./LineDrawer");

function loadLineShape(_x) {
  return _loadLineShape.apply(this, arguments);
}

function _loadLineShape() {
  _loadLineShape = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(engine) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return engine.addShape("line", new LineDrawer_1.LineDrawer());

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadLineShape.apply(this, arguments);
}

exports.loadLineShape = loadLineShape;